import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum DisableAccountsFormErrorStatesEnum {
    BlockTradingAccountFailed = ErrorStateScheduleEnum.DisableAccountsFormStatesStartIndex,
    DisableAccountsRequestsNotFound
}
